import React from 'react';

interface CardProps {
  border?: string;
  className?: string;
  children?: React.ReactNode;
  role?: string;
  'aria-label'?: string;
}

function CardBase({ border, className = '', children, ...rest }: CardProps) {
  const borderMap: Record<string, string> = {
    primary: 'border border-primary',
    danger: 'border border-error',
    success: 'border border-success',
    warning: 'border border-warning',
  };
  const borderClass = border ? (borderMap[border] || `border border-${border}`) : '';
  return (
    <div className={`card bg-base-100 shadow-sm ${borderClass} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

interface SubProps {
  className?: string;
  children?: React.ReactNode;
}

function CardHeader({ className = '', children }: SubProps) {
  return <div className={`card-header px-4 py-3 border-b border-base-300 bg-base-200/50 font-medium ${className}`.trim()}>{children}</div>;
}

function CardBody({ className = '', children }: SubProps) {
  return <div className={`card-body p-4 ${className}`.trim()}>{children}</div>;
}

function CardTitle({ className = '', children }: SubProps) {
  return <h5 className={`card-title ${className}`.trim()}>{children}</h5>;
}

function CardText({ className = '', children }: SubProps) {
  return <p className={`card-text ${className}`.trim()}>{children}</p>;
}

function CardFooter({ className = '', children }: SubProps) {
  return <div className={`card-footer px-4 py-3 border-t border-base-300 ${className}`.trim()}>{children}</div>;
}

const Card = Object.assign(CardBase, {
  Header: CardHeader,
  Body: CardBody,
  Title: CardTitle,
  Text: CardText,
  Footer: CardFooter,
});

export default Card;
